
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Press() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    outlet: '',
    topic: '',
    deadline: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Press inquiry submitted:', formData);
    // Handle form submission
  };

  const pressReleases = [
    {
      date: 'July 11, 2025',
      title: 'Osem Dynamics LLC Launches MandaPost: Revolutionary AI-Powered Social Media Platform',
      description: 'Washington, DC - First 3 months free for early adopters',
      link: '#release-1',
    },
    {
      date: 'June 2025',
      title: 'MandaPost Secures $15M Series A Funding',
      description: 'Investment to accelerate AI development and global expansion',
      link: '#release-2',
    },
    {
      date: 'May 2025',
      title: 'MandaPost Beta Program Surpasses 10,000 Users',
      description: 'Early adopters see 70% reduction in social media management time',
      link: '#release-3',
    },
  ];

  const mediaAssets = [
    {
      icon: 'ri-image-line',
      title: 'Brand Logos',
      description: 'PNG, SVG, and EPS formats',
      action: 'Download',
    },
    {
      icon: 'ri-palette-line',
      title: 'Brand Guidelines',
      description: 'Colors, fonts, and usage rules',
      action: 'Download',
    },
    {
      icon: 'ri-user-line',
      title: 'Headshots',
      description: 'Executive team photos',
      action: 'Download',
    },
    {
      icon: 'ri-slideshow-line',
      title: 'Product Screenshots',
      description: 'High-resolution UI images',
      action: 'Download',
    },
  ];

  const quickFacts = [
    {
      label: 'Founded',
      value: '2024',
    },
    {
      label: 'Headquarters',
      value: 'Washington, DC',
    },
    {
      label: 'Team Size',
      value: '25+ members',
    },
    {
      label: 'Launch Date',
      value: 'July 11, 2025',
    },
    {
      label: 'Funding',
      value: '$15M Series A',
    },
    {
      label: 'Focus',
      value: 'AI-Powered Social Media',
    },
  ];

  const mediaFAQ = [
    {
      question: 'What makes MandaPost different from other social media management tools?',
      answer: 'MandaPost is the first AI-powered platform that combines agentic AI marketing calendars, intelligent content creation, and adaptive posting strategies. Our AI doesn\'t just schedule posts—it actively plans, creates, and optimizes your entire social media strategy.',
    },
    {
      question: 'Who is the target audience for MandaPost?',
      answer: 'MandaPost serves content creators, influencers, small business owners, and marketing agencies looking to scale their social media presence with intelligent automation while maintaining authenticity and engagement.',
    },
    {
      question: 'Is MandaPost available for interviews?',
      answer: 'Yes! Our executive team and product experts are available for interviews. Please submit a request through our media contact form, and we\'ll respond within 24 hours.',
    },
    {
      question: 'Can we access beta features or early product demos?',
      answer: 'Absolutely. We offer exclusive product demos and early access to new features for media partners. Contact our press team to schedule a personalized walkthrough.',
    },
  ];

  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#22577A] to-[#38a3a5] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full text-white font-medium mb-6">
              <i className="ri-newspaper-line mr-2"></i>
              Press & Media
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Press Inquiries &
              <span className="block">Media Resources</span>
            </h1>

            <p className="text-xl lg:text-2xl text-white/90 mb-10 leading-relaxed">
              Get the latest news, press releases, and media assets from MandaPost. We're here to help you tell our story.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#contact-form"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-xl font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                Submit Press Inquiry
              </a>
              <a
                href="#press-kit"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-xl font-semibold text-lg hover:bg-white/10 transition-all cursor-pointer"
              >
                <i className="ri-download-line"></i>
                Download Press Kit
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Media Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-2xl border-2 border-[#66b3ff]/30">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#22577A] mb-2">Press Inquiries</h3>
              <a href="mailto:press@mandapost.com" className="text-[#38a3a5] hover:underline">
                press@mandapost.com
              </a>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-2xl border-2 border-[#66b3ff]/30">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#22577A] mb-2">Media Hotline</h3>
              <a href="tel:+1-202-555-0199" className="text-[#38a3a5] hover:underline">
                +1 (202) 555-0199
              </a>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-2xl border-2 border-[#66b3ff]/30">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#22577A] mb-2">Response Time</h3>
              <p className="text-gray-700">Within 24 hours</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Facts */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-[#e4f4ff]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-4">
              Quick Facts
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Essential information about MandaPost at a glance
            </p>
          </div>

          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
            {quickFacts.map((fact, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 border-2 border-gray-200 text-center hover:border-[#66b3ff] hover:shadow-lg transition-all"
              >
                <div className="text-sm font-semibold text-gray-500 uppercase mb-2">
                  {fact.label}
                </div>
                <div className="text-xl font-bold text-[#22577A]">{fact.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Recent Press Releases */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-4">
              Recent Press Releases
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Latest news and announcements from MandaPost
            </p>
          </div>

          <div className="space-y-6">
            {pressReleases.map((release, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-[#66b3ff] hover:shadow-xl transition-all cursor-pointer group"
              >
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div className="flex-1">
                    <div className="text-sm font-semibold text-[#38a3a5] mb-2">
                      {release.date}
                    </div>
                    <h3 className="text-2xl font-bold text-[#22577A] mb-3 group-hover:text-[#38a3a5] transition-colors">
                      {release.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">{release.description}</p>
                  </div>
                  <div className="flex-shrink-0">
                    <a
                      href={release.link}
                      className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-lg font-semibold hover:shadow-lg transition-all"
                    >
                      Read More
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Press Kit & Media Assets */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-[#e4f4ff]/10" id="press-kit">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-4">
              Press Kit & Media Assets
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Download logos, brand guidelines, and official product images
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {mediaAssets.map((asset, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#66b3ff] hover:shadow-xl transition-all text-center cursor-pointer group"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                  <i className={`${asset.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#22577A] mb-2">{asset.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{asset.description}</p>
                <button className="w-full px-4 py-2 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-lg font-semibold hover:shadow-lg transition-all">
                  <i className="ri-download-line mr-2"></i>
                  {asset.action}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Media FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-4">
              Media FAQ
            </h2>
            <p className="text-xl text-gray-600">
              Commonly asked questions from journalists and media
            </p>
          </div>

          <div className="space-y-6">
            {mediaFAQ.map((item, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-xl p-8 border-2 border-[#66b3ff]/30"
              >
                <h3 className="text-xl font-bold text-[#22577A] mb-3 flex items-start">
                  <i className="ri-question-line mr-3 text-[#38a3a5] flex-shrink-0 mt-1"></i>
                  {item.question}
                </h3>
                <p className="text-gray-700 leading-relaxed ml-8">{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-20 bg-gradient-to-br from-[#22577A] to-[#38a3a5]" id="contact-form">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-send-plane-line text-4xl text-white"></i>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Submit a Press Inquiry
            </h2>
            <p className="text-xl text-white/90">
              Fill out the form below and our press team will get back to you within 24 hours
            </p>
          </div>

          <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#66b3ff] focus:outline-none transition-colors"
                  placeholder="Jane Smith"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#66b3ff] focus:outline-none transition-colors"
                  placeholder="jane@newsoutlet.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Media Outlet *
                </label>
                <input
                  type="text"
                  required
                  value={formData.outlet}
                  onChange={(e) => setFormData({ ...formData, outlet: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#66b3ff] focus:outline-none transition-colors"
                  placeholder="TechCrunch"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Story Deadline
                </label>
                <input
                  type="date"
                  value={formData.deadline}
                  onChange={(e) => setFormData({ ...formData, deadline: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#66b3ff] focus:outline-none transition-colors"
                />
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Topic/Story Angle *
              </label>
              <input
                type="text"
                required
                value={formData.topic}
                onChange={(e) => setFormData({ ...formData, topic: e.target.value })}
                className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#66b3ff] focus:outline-none transition-colors"
                placeholder="AI in social media marketing"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Message/Questions *
              </label>
              <textarea
                required
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                rows={6}
                className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#66b3ff] focus:outline-none transition-colors resize-none"
                placeholder="Please provide details about your story, questions for our team, or interview requests..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-4 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-xl font-semibold text-lg hover:shadow-2xl hover:scale-[1.02] transition-all"
            >
              Submit Press Inquiry
            </button>

            <p className="text-sm text-gray-600 text-center mt-4">
              * Required fields. We typically respond within 24 hours.
            </p>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
